import { useEffect } from "react";
import { setHomework, setMilestone, useHomework } from "./index.js";
import { setHomeworkTodo } from "./homework-actions.js";
import { useApi } from "../api.js";

export const useHomeworkTodo = (userId) => {
  const [homework, dispatch] = useHomework();
  const api = useApi();
  const todo = homework.todo[userId || "*"];

  useEffect(() => {
    if (!todo) {
      // Load homework to do
      api.getHomeworkTodo(userId).then((res) => {
        // Compute stats
        res.forEach((list) => {
          list.done = 0;
          list.total = 0;

          list.types.forEach((type) => {
            type.done = 0;
            type.total = 0;

            type.categories.forEach((category) => {
              category.done = 0;
              category.total = 0;

              category.works.forEach((work) => {
                work.done = 0;
                work.total = 0;

                (work.milestones || []).forEach((milestone) => {
                  if (milestone.done) {
                    work.done++;
                    category.done++;
                    type.done++;
                    list.done++;
                  }

                  work.total++;
                  category.total++;
                  type.total++;
                  list.total++;
                });

                work.percent = (work.done * 100) / Math.max(work.total, 1);
              });

              category.percent = (category.done * 100) / Math.max(category.total, 1);
            });

            type.percent = (type.done * 100) / Math.max(type.total, 1);
          });

          list.percent = (list.done * 100) / Math.max(list.total, 1);
        });

        setHomeworkTodo(dispatch, userId, res);
      });
    }
  }, [todo, userId]);

  return todo;
};

export const useH = (homeworkId, userId) => {
  const [homework, dispatch] = useHomework();
  const api = useApi();
  const h = (homework.homeworks[homeworkId] || {})[userId || "*"];

  useEffect(() => {
    if (!h && homeworkId) {
      api.getHomework(homeworkId, userId).then((res) => {
        setHomework(dispatch, homeworkId, userId, res);
      });
    }
  }, [h, homeworkId, userId]);

  return h;
};

export const useMilestone = (milestoneId, userId) => {
  const [homework, dispatch] = useHomework();
  const api = useApi();
  const h = (homework.milestones[milestoneId] || {})[userId || "*"];

  useEffect(() => {
    if (!h && milestoneId) {
      api.getMilestone(milestoneId, userId).then((res) => {
        setMilestone(dispatch, milestoneId, userId, res);
      });
    }
  }, [h, milestoneId, userId]);

  return h;
};
